/**
 * Include keys for nested supplier settings on event descriptions.
 * Both camelCase and snake_case are listed for API serializer compatibility.
 */
export const KFT_EVENT_REQUEST_SETTINGS_INCLUDES = [
  'date_request_settings',
  'private_event_settings',
] as const

export const mergeKftEventDescriptionSettingsIncludes = (
  include: string[]
): string[] => [...include, ...KFT_EVENT_REQUEST_SETTINGS_INCLUDES]
